export function installChunkReload(target: Window = window): () => void {
  function onPreloadError(event: Event) {
    if (reloadedRecently(target)) return;
    if (!markReload(target)) return;
    event.preventDefault();
    target.location.reload();
  }
  target.addEventListener("vite:preloadError", onPreloadError);
  return () => target.removeEventListener("vite:preloadError", onPreloadError);
}

function reloadedRecently(target: Window): boolean {
  try {
    const at = Number(target.sessionStorage.getItem(RELOAD_KEY));
    const age = Date.now() - at;
    return at > 0 && age >= 0 && age < RELOAD_GUARD_MS;
  } catch {
    return true;
  }
}

function markReload(target: Window): boolean {
  try {
    target.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
}

const RELOAD_KEY = "simon.chunkReload";

const RELOAD_GUARD_MS = 30_000;
